// Hook: Fetches Jira child work items (subtasks) for a JIRA-sourced workflow.
// Used in the read-only Tasks tab when source === 'JIRA'.

import { useGetJiraChildWorkItemsQuery } from "#graphql/supergraphHooks";

export interface JiraChildWorkItem {
  id: string;
  key: string;
  summary: string;
  status: string;
  statusCategoryName: string | null;
  assignedTo: string | null;
  responsibleParty: string | null;
}

interface UseJiraChildWorkItemsResult {
  items: JiraChildWorkItem[];
  loading: boolean;
  error: Error | null;
}

export function useJiraChildWorkItems(
  parentIssueKey: string | null | undefined,
): UseJiraChildWorkItemsResult {
  const { data, loading, error } = useGetJiraChildWorkItemsQuery({
    variables: { parentIssueKey: parentIssueKey ?? "" },
    skip: !parentIssueKey,
    fetchPolicy: "network-only",
  });

  const items: JiraChildWorkItem[] = (data?.childWorkItems?.items ?? []).map((item) => ({
    id: item.id,
    key: item.key,
    summary: item.summary,
    status: item.status,
    statusCategoryName: item.statusCategoryName ?? null,
    assignedTo: item.assignedTo?.displayName ?? null,
    responsibleParty: item.fundAdministrationDepartment ?? null,
  }));

  return { items, loading, error: error ?? null };
}
